import { Injectable } from "@angular/core";
import { FinancialBalance } from "src/app/ui/models/domains/pbm/financial-satatement/financial-balance";
import { AbstractParser } from "../../parser";

@Injectable()
export class FindFinancialBalanceBySocialNumberParser extends AbstractParser<FinancialBalance> {
  parse(payload: any): FinancialBalance {
    const financialBalance = new FinancialBalance();
    financialBalance.setAvailable(payload.Available);
    financialBalance.setCycleClosedDay(payload.CycleClosedDay);
    financialBalance.setLimit(payload.Limit);
    financialBalance.setPayroll(payload.Payroll);
    financialBalance.setSales(payload.Sales);
    financialBalance.setSubsidy(payload.Subsidy);
    financialBalance.setLimitType(payload.LimitType);
    return financialBalance;
  }
}
